import { localeNames } from 'common/constants/localeTypes'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { TFunction } from 'i18next'

export interface LocalesOptionsInterface {
  value: PageLocaleEnum
  label: string
}

export const getLocalesOptions = (t: TFunction): LocalesOptionsInterface[] => {
  const options: LocalesOptionsInterface[] = Object.values(PageLocaleEnum).map(
    locale => ({
      value: locale,
      label: t(localeNames[locale]),
    }),
  )

  return options
}
